import Marionette from 'backbone.marionette';
import { PasswordChangeView, PasswordChangeConfirmationView } from '../../views';


export default class PasswordController extends Marionette.Object {
	passwordChange() {
		const rootView = this.getOption( 'rootView' );
		rootView.getRegion( 'main' ).show(new PasswordChangeView());
	}

	passwordChangeConfirmation() {
		const rootView = this.getOption( 'rootView' );
		rootView.getRegion( 'main' ).show(new PasswordChangeConfirmationView());
	}
}